module.exports = __webpack_public_path__ + "img/navigate_before-24px.33483b91.svg";